
import { Record } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, string_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { int32ToString, createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { append, singleton, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { IconArrowRight, IconChevronLeft, IconDownload, IconCheckmark } from "../Components/Icon.js";
import { map, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { createElement } from "react";
import React from "react";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { useTranslation } from "react-i18next";
import { mapIndexed } from "../fable_modules/fable-library-js.5.0.0-rc.2/Array.js";

const accent = "#15B897";

const accentSoft = "#E4F7F2";

const accentInk = "#0B7A65";

const textMuted = "#6B7280";

const textSubtle = "#98A0A8";

const borderColor = "#E6E8EB";

const surface = "#FFFFFF";

const surface2 = "#F8FAFA";

class Step extends Record {
    constructor(Title, Desc) {
        super();
        this.Title = Title;
        this.Desc = Desc;
    }
}

function Step_$reflection() {
    return record_type("OnboardingHub.ImportGuide.Step", [], Step, () => [["Title", string_type], ["Desc", string_type]]);
}

function steps(t) {
    return [new Step(t("onboarding.import_guide.step_1_title"), t("onboarding.import_guide.step_1_desc")), new Step(t("onboarding.import_guide.step_2_title"), t("onboarding.import_guide.step_2_desc")), new Step(t("onboarding.import_guide.step_3_title"), t("onboarding.import_guide.step_3_desc"))];
}

function stepCircle(n, isActive, isDone) {
    let elems;
    return reactElement("div", createObj(ofArray([["style", {
        width: 28,
        height: 28,
        borderRadius: 999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 13 + "px",
        fontWeight: 600,
        flexShrink: 0,
        backgroundColor: (isActive ? true : isDone) ? accent : "#F3F4F6",
        color: (isActive ? true : isDone) ? surface : textMuted,
    }], (elems = toList(delay(() => (isDone ? singleton(IconCheckmark(14)) : singleton(reactElement("span", {
        children: [int32ToString(n + 1)],
    }))))), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function StepItem(props) {
    let elems_1, elems;
    const patternInput = reactApi.useState(false);
    const setHovered = patternInput[1];
    return reactElement("button", createObj(ofArray([["onMouseEnter", (_arg) => {
        setHovered(true);
    }], ["onMouseLeave", (_arg_1) => {
        setHovered(false);
    }], ["onClick", (_arg_2) => {
        props.OnClick();
    }], ["style", {
        display: "flex",
        alignItems: "flex-start",
        gap: 14 + "px ",
        padding: ((16 + "px ") + 20) + "px",
        borderRadius: 10,
        textAlign: "left",
        cursor: "pointer",
        width: 100 + "%",
        backgroundColor: props.IsActive ? accentSoft : (patternInput[0] ? "#F9FAFB" : "transparent"),
        border: props.IsActive ? concat("1px solid ", ...accent) : "1px solid transparent",
        transition: "all 0.15s ease",
    }], (elems_1 = [stepCircle(props.Index, props.IsActive, props.IsDone), reactElement("div", createObj(singleton_1((elems = [reactElement("div", {
        style: {
            fontWeight: 600,
            fontSize: 14 + "px",
            color: "#14181B",
            marginBottom: 4,
        },
        children: props.Step.Title,
    }), reactElement("p", {
        style: {
            fontSize: 13 + "px",
            color: textMuted,
            margin: 0,
            lineHeight: 1.5,
        },
        children: props.Step.Desc,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function step1Visual(t) {
    let elems_2, elems_1, elems;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((40 + "px ") + 32) + "px",
    }], (elems_2 = [reactElement("div", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
            marginBottom: 8,
        },
        children: t("onboarding.import_guide.visual_1_label"),
    }), reactElement("h2", {
        style: {
            fontSize: 20 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 16) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.import_guide.visual_1_heading"),
    }), reactElement("div", createObj(ofArray([["style", {
        backgroundColor: surface2,
        border: "1px dashed #9CA3AF",
        borderRadius: 10,
        padding: 32,
        textAlign: "center",
        color: textMuted,
    }], (elems_1 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        marginBottom: 16,
        opacity: 0.5,
    }], (elems = [IconDownload(36)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", {
        style: {
            "font-family": "JetBrains Mono, monospace",
            fontSize: 13 + "px",
            marginBottom: 6,
            color: "#14181B",
        },
        children: t("onboarding.import_guide.visual_1_filename"),
    }), reactElement("div", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
        },
        children: t("onboarding.import_guide.visual_1_hint"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function step2Visual(t) {
    let elems_2, elems_1, children, elems, children_4;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((32 + "px ") + 32) + "px",
    }], (elems_2 = [reactElement("div", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
            marginBottom: 8,
        },
        children: t("onboarding.import_guide.visual_2_label"),
    }), reactElement("h2", {
        style: {
            fontSize: 20 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 16) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.import_guide.visual_2_heading"),
    }), reactElement("table", createObj(ofArray([["style", {
        width: 100 + "%",
        "border-collapse": "collapse",
        "font-family": "JetBrains Mono, monospace",
        fontSize: 11 + "px",
    }], (elems_1 = [(children = singleton_1(reactElement("tr", createObj(ofArray([["style", {
        backgroundColor: accentSoft,
    }], (elems = map((h) => reactElement("th", {
        style: {
            padding: ((8 + "px ") + 10) + "px",
            border: "1px solid #D1FAF0",
            textAlign: "left",
            fontWeight: 600,
            color: accentInk,
        },
        children: h,
    }), ofArray(["Hersteller*", "Modell*", "Seriennr.", "Kategorie", "Lager"])), ["children", reactApi.Children.toArray(Array.from(elems))])])))), reactElement("thead", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), (children_4 = map((row) => {
        const children_2 = map((cell) => reactElement("td", {
            style: {
                padding: ((8 + "px ") + 10) + "px",
                border: "1px solid #E6E8EB",
            },
            children: cell,
        }), row);
        return reactElement("tr", {
            children: reactApi.Children.toArray(Array.from(children_2)),
        });
    }, ofArray([ofArray(["AMMANN", "APR25/50", "142001441", "Baugerät", "Werkzeuglager"]), ofArray(["BOSCH", "GSR-18V", "8871203", "Werkzeug", "Hauptlager"]), ofArray(["Apple", "MacBook Pro 14\"", "C02X5D3H", "IT", "Büro HH"]), ofArray(["Ford", "Transit", "GP-T 203", "Fahrzeug", "Fuhrpark"])])), reactElement("tbody", {
        children: reactApi.Children.toArray(Array.from(children_4)),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

function step3Visual(t) {
    let elems_4, elems_2, elems, elems_1, elems_3;
    return reactElement("div", createObj(ofArray([["style", {
        padding: ((32 + "px ") + 32) + "px",
    }], (elems_4 = [reactElement("div", {
        style: {
            fontSize: 12 + "px",
            color: textSubtle,
            marginBottom: 8,
        },
        children: t("onboarding.import_guide.visual_3_label"),
    }), reactElement("h2", {
        style: {
            fontSize: 20 + "px",
            fontWeight: 600,
            margin: ((((((0 + "px ") + 0) + "px ") + 16) + "px ") + 0) + "px",
            color: "#14181B",
        },
        children: t("onboarding.import_guide.visual_3_heading"),
    }), reactElement("div", createObj(ofArray([["style", {
        backgroundColor: accentSoft,
        border: concat("1px solid ", ...accent),
        borderRadius: 8,
        padding: 14,
        marginBottom: 12,
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
    }], (elems_2 = [reactElement("div", createObj(ofArray([["style", {
        color: accentInk,
    }], (elems = [IconCheckmark(16)], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["style", {
        fontSize: 13 + "px",
    }], (elems_1 = [reactElement("strong", {
        children: "192 Zeilen erkannt",
    }), " — 188 bereit, 4 mit Hinweisen"], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", createObj(ofArray([["style", {
        background: "#FFFBEB",
        border: "1px solid #E8B24B",
        borderRadius: 8,
        padding: 12,
        fontSize: 12 + "px",
        color: "#92400E",
    }], (elems_3 = [reactElement("strong", {
        children: "Zeile 23: ",
    }), "Kategorie \"Baugeraet\" unbekannt — Vorschlag: ", reactElement("em", {
        children: "Baugerät",
    }), " anlegen."], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

export function ImportGuideView(props) {
    let elems_7, elems_1, elems, elems_6, elems_4, elems_5;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(0);
    const activeStep = patternInput_1[0] | 0;
    return reactElement("div", createObj(ofArray([["style", {
        maxWidth: 1180,
        margin: (0 + "px ") + "auto",
        paddingTop: 28,
    }], (elems_7 = [reactElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 10 + "px ",
        marginBottom: 32,
    }], (elems_1 = [reactElement("button", createObj(ofArray([["onClick", (_arg) => {
        props.OnBack();
    }], ["style", {
        display: "flex",
        alignItems: "center",
        gap: 6 + "px ",
        fontSize: 13 + "px",
        color: textMuted,
        cursor: "pointer",
        backgroundColor: "transparent",
        border: "none",
        padding: 0,
    }], (elems = [IconChevronLeft(14), t("onboarding.import_guide.back")], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("span", {
        style: {
            color: borderColor,
        },
        children: "/",
    }), reactElement("h1", {
        style: {
            fontSize: 22 + "px",
            fontWeight: 600,
            margin: 0,
            color: "#14181B",
        },
        children: t("onboarding.import_guide.title"),
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["style", {
        display: "grid",
        "grid-template-columns": "380px 1fr",
        gap: 24 + "px ",
        alignItems: "flex-start",
    }], (elems_6 = [reactElement("div", createObj(ofArray([["style", {
        backgroundColor: surface,
        border: concat("1px solid ", ...borderColor),
        borderRadius: 14,
        padding: ((8 + "px ") + 8) + "px",
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
    }], (elems_4 = toList(delay(() => append(singleton(reactElement("h3", {
        style: {
            fontSize: 11 + "px",
            fontWeight: 600,
            color: textSubtle,
            margin: ((((((8 + "px ") + 12) + "px ") + 4) + "px ") + 12) + "px",
            textTransform: "uppercase",
            "letter-spacing": "0.07em",
        },
        children: t("onboarding.import_guide.steps_label"),
    })), delay(() => append(ofArray(mapIndexed((i, step) => createElement(StepItem, {
        Index: i,
        IsActive: activeStep === i,
        IsDone: activeStep > i,
        OnClick: () => {
            patternInput_1[1](i);
        },
        Step: step,
    }), steps(t))), delay(() => {
        let elems_3, elems_2;
        return singleton(reactElement("div", createObj(ofArray([["style", {
            marginTop: 8,
            padding: ((((((12 + "px ") + 12) + "px ") + 4) + "px ") + 12) + "px",
            borderTop: (((1 + "px ") + "solid") + " ") + borderColor,
        }], (elems_3 = [reactElement("button", createObj(ofArray([["onClick", (_arg_1) => {
            props.OnGoToImporter();
        }], ["style", {
            display: "flex",
            alignItems: "center",
            gap: 8 + "px ",
            width: 100 + "%",
            padding: ((12 + "px ") + 16) + "px",
            backgroundColor: accent,
            color: surface,
            borderRadius: 10,
            cursor: "pointer",
            fontWeight: 600,
            fontSize: 14 + "px",
            border: "none",
        }], (elems_2 = [reactElement("span", {
            style: {
                flexGrow: 1,
                textAlign: "left",
            },
            children: t("onboarding.import_guide.go_to_importer"),
        }), IconArrowRight(16)], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("p", {
            style: {
                fontSize: 11 + "px",
                color: textSubtle,
                margin: ((((((6 + "px ") + 4) + "px ") + 0) + "px ") + 4) + "px",
            },
            children: t("onboarding.import_guide.importer_hint"),
        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), reactElement("div", createObj(ofArray([["style", {
        backgroundColor: surface,
        border: concat("1px solid ", ...borderColor),
        borderRadius: 14,
        overflow: "hidden",
        minHeight: 400,
    }], (elems_5 = toList(delay(() => ((activeStep === 0) ? singleton(step1Visual(t)) : ((activeStep === 1) ? singleton(step2Visual(t)) : singleton(step3Visual(t)))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

